@if (!areAllFieldsHidden) {
  <div class="wc-section {{ props.fieldGroupClassName }}">
    <div class="wc-section-header">
      <div class="d-flex align-items-center">
        @if (props.canDeactivate === true) {
          <mat-checkbox [(ngModel)]="props.isActive" (change)="onToggle($event)">
            <h3 class="text bold m-0">{{ props.label | apmTranslate }}</h3>
          </mat-checkbox>
        }
        @if (props.canDeactivate === undefined) {
          <h3 class="text bold">{{ props.label | apmTranslate }}</h3>
        }
      </div>
      @if (props.subtitle) {
        <div class="italic-2">{{ props.subtitle | apmTranslate }}</div>
      }
    </div>
    <div class="wc-section-body" [ngClass]="{ 'bg-editable-row': props.editable && (isEditing$ | async) }">
      <ng-container #fieldComponent></ng-container>
    </div>
  </div>
}
